export default __webpack_public_path__ + "static/media/ECWSurveys.02132303.webp";